<div class="w-[350px] flex items-center px-2" [class.slide-in]="showPost()">
        @if (activePost) {
            <app-blog-card [post]="activePost"></app-blog-card>
        }
</div>